import { createContext, useContext, useState, useCallback } from "react";

const LivePlayerContext = createContext(null);

export function LivePlayerProvider({ children }) {
  // "open" = le direct est actif (iframe montée). Il se docke en grand sur le
  // tableau de bord et se réduit en lecteur flottant sur les autres pages.
  const [open, setOpen] = useState(() => localStorage.getItem("livePlayerOpen") === "1");

  const openPlayer = useCallback(() => {
    setOpen(true);
    localStorage.setItem("livePlayerOpen", "1");
  }, []);
  const closePlayer = useCallback(() => {
    setOpen(false);
    localStorage.setItem("livePlayerOpen", "0");
  }, []);

  return (
    <LivePlayerContext.Provider value={{ open, openPlayer, closePlayer }}>
      {children}
    </LivePlayerContext.Provider>
  );
}

export const useLivePlayer = () => {
  const ctx = useContext(LivePlayerContext);
  if (!ctx) throw new Error("useLivePlayer must be used within LivePlayerProvider");
  return ctx;
};
